import { trimEnd, trimStart } from 'lodash';

const getUrl = base => uri => `${trimEnd(base, '/')}/${trimStart(uri, '/')}`;

export default function publicSiteUrl() {
    return {
        serviceLink: getUrl('/link/'),
    };
}
